var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"active":this.$store.state.preload,"is-full-page":true,"width":45,"color":'#007bff'},on:{"update:active":function($event){return _vm.$set(this.$store.state, "preload", $event)}}}),_c('AdminContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }